export const PageSize = {
    small: 10,
    medium: 25,
    large: 50,
};
